<template>
  <div class="col-12 pt-3 pb-3 pl-4 d-flex flex-wrap">
    <div class="d-flex items-center gap-column w-100">
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="provider">Provedor</label>
        <b-form-select
          id="provider-select"
          class="w-100"
          v-model="type"
          :options="types"
          required
        ></b-form-select>
      </div>
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="provider">Modo</label>
        <b-form-select
          id="mode-select"
          class="w-100"
          v-model="active"
          :options="modes"
          required
        ></b-form-select>
      </div>
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="number">Número</label>
        <v-select
          v-model="number"
          :options="listNumber"
          :reduce="x => x.value"
          class="w-100"
          label="text"
        >
          <template v-slot:no-options>{{
            $lang.Common.PlaceholderSelect
          }}</template>
        </v-select>
      </div>
      <div class="d-flex align-items-end w-50 justify-content-end">
        <defaultbutton
          class="defaultbutton col"
          :onClick="() => searchFilter()"
          btnVariant="btn-third"
          icon="fas fa-search"
          text="Filtrar"
        />
        <defaultbutton
          class="defaultbutton col color-bg"
          btnVariant="bg-secondary btn-third btn-outline-secondary"
          :onClick="() => addModal()"
          icon="fas fa-plus"
          text="Adicionar"
        />
        <defaultbutton
          class="defaultbutton col"
          :onClick="() => clear()"
          btnVariant="bg-secondary btn-third"
          icon="fas fa-trash"
          text="Limpar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DropDownMensagensAutomaticas from '../../mensagensautomaticas/components/dropdown/DropDownMensagensAutomaticas.vue'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'

export default {
  name: 'ProviderFilter',
  data () {
    return {
      active: null,
      type: null,
      number: null,
      listNumber: []
    }
  },
  components: {
    DropDownMensagensAutomaticas,
    defaultbutton
  },
  async created () {
    const response = await NumRepository.getNumberAll()
    this.listNumber = response.data.numbers
  },
  methods: {
    clear () {
      this.active = null
      this.number = null
      this.type = null
    },
    async searchFilter () {
      const requestConfig = {
        params: {
          active: this.active,
          type: this.type,
          number: this.number
        }
      }
      console.log(requestConfig)
      try {
        if (this.active === null && this.number === null && this.type === null) {
          const res = await NumRepository.getEnvAll()
          this.$emit('filter', res.data.content)
        } else {
          const res = await NumRepository.getEnvAll(requestConfig)
          this.$emit('filter', res.data.content)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    addModal () {
      this.$emit('clicked-open')
    }
  },
  computed: {
    types () {
      return [
        {
          text: 'Meta',
          value: 'WHATS_META'
        },
        {
          text: 'Whatsapp',
          value: 'WHATS_WPP'
        }
      ]
    },
    modes () {
      return [
        {
          text: 'Ativo',
          value: 1
        },
        {
          text: 'Desativado',
          value: 0
        }
      ]
    }
  }
}
</script>

<style scoped>
  .sizing-width {
    width: 22%;
  }

  .gap-column {
    column-gap: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/filter/ProvedorFilter.vue